<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" :disabled="disabled">
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="司机姓名" prop="driverName">
            <el-input
              v-model="formData.driverName"
              placeholder="请输入司机姓名"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="司机手机号" prop="driverMobile">
            <el-input
              v-model="formData.driverMobile"
              placeholder="请输入司机手机号"
              maxlength="11"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="司机身份证号" prop="driverID">
            <el-input
              v-model="formData.driverID"
              placeholder="请输入司机身份证号"
              maxlength="18"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="所属承运商" prop="carrierCode">
            <dict-select
              style="width: 100%"
              size="medium"
              filterable
              v-model="formData.carrierCode"
              url="/master/carrier/info/select"
              placeholder="请选择承运商"
              clearable
              @change="changeCarrierCode()"
            />
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="司机归属" prop="driverOwnerType">
            <dict-select
              clearable
              filterable
              v-model="formData.driverOwnerType"
              placeholder="请选择司机归属"
              default
              :body="driverOwnerTypeDictParams"
            >
            </dict-select>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="驾照类型">
            <dict-select
              clearable
              filterable
              v-model="formData.driverLicenseType"
              placeholder="请选择驾照类型"
              default
              :body="driverLicenseTypeDictParams"
            >
            </dict-select>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="司机驾驶证号">
            <el-input
              v-model="formData.driverLicense"
              placeholder="请输入司机驾驶证号"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="驾驶证有效期">
            <el-date-picker
              v-model="formData.driverLicenseValidity"
              placeholder="请输入驾驶证有效期"
              style="width:100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="驾驶证到期提醒天数">
            <el-input-number
              v-model="formData.driverLicenseValidityAlarmDays"
              placeholder="请输入驾驶证到期提醒天数"
              :min="0"
              :max="365"
              :precision="0"
              controls-position="right"
              style="width:100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="开户银行">
            <el-input
              v-model="formData.depositBank"
              placeholder="请输入开户银行"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="银行账号" prop="bankAccount">
            <el-input
              v-model="formData.bankAccount"
              placeholder="请输入银行账号"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="账号名称">
            <el-input
              v-model="formData.bankAccountName"
              placeholder="请输入账号名称"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="备注信息">
            <el-input
              v-model="formData.driverRemarks"
              placeholder="请输入备注信息"
              rows="3"
              type="textarea"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="机构" prop="orgCode">
            <org-cascader
              :valueString.sync="formData.orgAllCode"
              :lastValue.sync="formData.orgCode"
              filterable
            />
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="可用状态" prop="driverStatus">
            <br />
            <el-radio-group v-model="formData.driverStatus">
              <el-radio label="Y">有效</el-radio>
              <el-radio label="N">无效</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    disabled: Boolean,
    code: String,
  },
  data() {
    return {
      driverLicenseTypeDictParams: { type: 'driverLicenseType' },
      driverOwnerTypeDictParams: { type: 'driverOwnerType' },
      formData: { driverStatus: 'Y' },
      rules: {
        driverName: [
          { required: true, message: '请输入司机姓名', trigger: 'blur' },
        ],
        driverMobile: [
          { required: true, message: '请输入司机手机号', trigger: 'blur' },
          { min: 11, message: '手机号码至少11位', trigger: 'blur' },
        ],
        carrierCode: [
          { required: true, message: '请选择承运商', trigger: 'change' },
        ],
        driverID: [
          // { required: true, message: '请输入司机身份证号', trigger: 'blur' },
          // { min: 18, message: '身份证号码至少18位', trigger: 'blur' },
          {
            validator(rule, value, callback) {
              if (value != '' && value != undefined){
                if (value.length < 18){
                  callback(new Error('身份证号至少18位'))
                }
                let driverIdNo = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
                if (driverIdNo.test(value)) {
                  callback()
                } else {
                  callback(new Error('请输入正确的身份证号'))
                }
              }else{
                callback()
              }
            },
          },
        ],
        driverOwnerType: [
          { required: true, message: '请选择司机归属', trigger: 'change' },
        ],
        driverStatus: [
          { required: true, message: '请选择可用状态', trigger: 'change' },
        ],
        orgCode: [{ required: true, message: '请选择机构', trigger: 'change' }],
        bankAccount: [
          {
            // required: false,
            // pattern: /^([1-9]{1})(\d{14}|\d{18})$/,
            // message: '请输入14位银行卡号',
            validator:(rule, value, callback) => {
              let reg = /^(\d{1})(\d{14,20})$/
              let numReg = /^\d+$/
              if (reg.test(value)){
                callback()
              }else{
                if (value === null || value === undefined || value === ''){
                  callback()
                }else if (numReg.test(value) && value.length > 21){
                  this.$confirm('当前输入的账号大于21位，请确认是否正确', '确认信息', {
                    type: 'warning'
                  }).then(() => {
                    callback()
                  }).catch(() => {
                    callback(new Error('请输入15~21位的银行账号'))
                  })
                }else if (numReg.test(value) && value.length < 15){
                  this.$confirm('当前输入的账号小于15位，请确认是否正确', '确认信息', {
                    type: 'warning'
                  }).then(() => {
                    callback()
                  }).catch(() => {
                    callback(new Error('请输入15~21位的银行账号'))
                  })
                }else{
                  callback(new Error('请输入15~21位的银行账号'))
                }
              }
            },
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.code) return
      this.$api
        .masterDriverDetailApi({
          driverCode: this.code,
        })
        .then((res) => {
          this.formData = res.body
          this.$emit('changeCarrierCode',this.formData.carrierCode)
        })
    },
    regMobile(mobile) {
      let flag = /^\d{11}$/.test(mobile)
      if (!flag) {
        this.$message.error('手机号码格式错误 请重新输入 手机号码固定11位')
      }
      return flag
    },

    async save() {
      let result = await validate.formValidate([this.$refs.form])
      let flag = this.regMobile(this.formData.driverMobile)
      if (!flag) {
        result = false
      }
      if (!result) return (this.backDialogVisible = false)
      let loadingInstance = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.$api
        .masterDriverSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          if (!this.code) {
            this.formData = { driverStatus: 'Y' }
            this.openEditPage({
              pageType: 'edit',
              code: res.body})
          }
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    openEditPage({ pageType, code }) {
      this.$router.push({
        name: 'master-driver-detail',
        params: { driverCode: code, pageType }
      })
    },
    changeCarrierCode(){
      if (this.code && this.formData.carrierCode){
        this.delVehicleByDriver()
        this.$api.masterDriverModiCarrrierApi({driverCode: this.code, carrierCode: this.formData.carrierCode})
        this.$emit('changeCarrierCode',this.formData.carrierCode)
      }
    },
    delVehicleByDriver(){
      const params = {
        driverCode: this.code,
        carrierCode: this.formData.carrierCode,
      }
      this.$api.masterDriverDelVehicleByDriverApi(params).then(() => {})
    },
  },
}
</script>
